import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import colors from '../colorPalette';
import settingsStore from '../models/settingsStore';
const Wrapper = styled.div `
  color: ${colors.white};
  padding: 16px;
  font-size: 14px;
  font-weight: 400;
  label {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    input, select {
      margin-right: 8px;
    }
  }
`;
const Settings = () => {
    const settings = settingsStore.use();
    return (_jsxs(Wrapper, { children: [_jsxs("label", { children: [_jsx("input", { type: "checkbox", checked: settings.showButton, onChange: event => settingsStore.patch({ showButton: event.target.checked }) }), "Show Button for opening devtools (You can always use Ctrl+Shift+S)"] }), _jsxs("label", { children: [_jsxs("select", { value: settings.badgeType, onChange: event => settingsStore.patch({ badgeType: event.target.value }), disabled: !settings.showButton, children: [_jsx("option", { value: "disabled", children: "Disable badge" }), _jsx("option", { value: "collections", children: "Collection count" }), _jsx("option", { value: "queries", children: "Query count" })] }), "Badge type"] })] }));
};
export default Settings;
